import { api } from "../helpers/apiHelper";
import { api as api3 } from "../helpers/apiHelperV3";
import { urls } from "./urls";

// General URLS
const API_CRYPTO_TRANSACTION = urls.cashier.API_CRYPTO_TRANSACTION();
const API_CURRENCIES = urls.cashier.API_CRYPTO_CURRENCIES();
const API_CRYPTO_TRANSACTIONS = urls.cashier.API_CRYPTO_TRANSACTIONS();

// Deposit URLS
const API_CRYPTO_DEPOSIT = urls.cashier.API_CRYPTO_DEPOSIT();
const API_DEPOSIT_RESULT = "/cashier/crypto/depositResult";

// Withdraw URLS
const API_CRYPTO_QUOTE = urls.cashier.API_CRYPTO_QUOTE();
const API_CRYPTO_WITHDRAW_AUTOMATIC =
  urls.cashier.API_CRYPTO_WITHDRAW_AUTOMATIC();

/**
 * Get a list of pending transactions
 */
export const getPendingCryptoTransactions = (): any => {
  const url = API_CRYPTO_TRANSACTIONS;
  return api3.get(url);
};
/**
 * Request to poll status of deposit
 */
export const pollStatus = (depositId: number): any => {
  const url = `${API_CRYPTO_TRANSACTION}/${depositId}`;
  return api3.get(url);
};
/**
 * Get list of available crypto currencies
 */
export const getCryptoCurrencies = (): any => {
  const url = API_CURRENCIES;
  return api3.get(url);
};

/**
 * Initial deposit request - Deposit will begin processing
 */
export const requestDepositQuote = (
  currency: string,
  fiatCurrency: string,
  fiatReceivable: number
): any => {
  const url = API_CRYPTO_DEPOSIT;
  const data = {
    cryptoCurrency: currency,
    fiatCurrency: fiatCurrency,
    fiatReceivable: fiatReceivable,
    type: "deposit",
  };
  return api3.post(url, data);
};
/**
 * Simulate deposit success
 * NOT USED CURRENTLY
 */
export const depositResult = (
  address: string,
  adminApproval: string,
  fiatCurrency: string,
  fiatReceivable: number
): any => {
  const url = API_DEPOSIT_RESULT;
  const data = {
    address: address,
    adminApproval: adminApproval,
    fiatCurrency: fiatCurrency,
    fiatReceivable: fiatReceivable,
  };
  return api.post(url, data);
};

/**
 * Initial withdraw request - Withdraw will begin processing
 */
export const requestWithdrawQuote = (
  cryptoCurrency: string,
  fiatCurrency: string,
  fiatAmount: number
): any => {
  const url = API_CRYPTO_QUOTE;
  const data = {
    cryptoCurrency: cryptoCurrency,
    fiatCurrency: fiatCurrency,
    fiatAmount: fiatAmount,
    type: "withdrawal",
  };
  return api3.post(url, data);
};
/**
 *  Withdraw without admin approval
 */
export const automaticWithdrawal = (
  address: string,
  receiveCurrency: string,
  fiat: string,
  receiveQuantity: number,
  quoteId: string
): any => {
  const url = API_CRYPTO_WITHDRAW_AUTOMATIC;
  const data = {
    address: address,
    receiveCurrency: receiveCurrency,
    fiat: fiat,
    receiveQuantity: receiveQuantity,
    quoteId: quoteId,
  };
  return api3.post(url, data);
};
